import { Location } from 'history'
import { parse } from 'query-string'

export const isPricingSourceRoute = (location: Location) => {
  const { source } = parse(location.search)
  return source === 'pricing'
}
